module.exports = __webpack_public_path__ + "img/house-chimney-crack.625b6bcd.svg";